import { render, staticRenderFns } from "./product-detail.vue?vue&type=template&id=ee9d44d8&scoped=true&"
import script from "./product-detail.vue?vue&type=script&lang=js&"
export * from "./product-detail.vue?vue&type=script&lang=js&"
import style0 from "./product-detail.vue?vue&type=style&index=0&id=ee9d44d8&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ee9d44d8",
  null
  
)

export default component.exports